<template>
  <v-container fluid pa-0>
    <slot name="modal"></slot>
    <v-card tile flat>
      <v-card-title>
        <slot name="left"></slot>
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Sök..."
          rounded
          single-line
          dense
          filled
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <MasterdataCreateButton
          v-if="components"
          :create-modal="components.createModal"
          :refetch="refetch"
        />
        <slot name="right"></slot>
      </v-card-title>
      <v-data-table
        v-model="selected"
        @click:row="item => $emit('row-click', item)"
        :loading="loading"
        :headers="headers"
        :items="data"
        :search="search"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :show-select="showSelect"
        :item-key="itemKey"
        :disable-pagination="!pagination"
        :hide-default-footer="!pagination"
        :options="{
          itemsPerPage: 50
        }"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, -1]
        }"
        fixed-header
        :height="tableHeight + (!pagination ? 48 : 0)"
      >
        <template v-slot:item.actions="{ item }">
          <template v-for="(actionItem, $i) in actions">
            <v-dialog
              :key="$i"
              v-model="item[`_show-${actionItem.type}-modal`]"
              width="600"
              persistent
            >
              <MasterdataModal
                :title="actionItem.title"
                v-if="item[`_show-${actionItem.type}-modal`]"
              >
                <component
                  :item="item"
                  :refetch="refetch"
                  :is="actionItem.component"
                  @close="item[`_show-${actionItem.type}-modal`] = false"
                />
              </MasterdataModal>
            </v-dialog>
          </template>
          <v-menu left>
            <template #activator="{ attrs, on }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <template v-for="(actionItem, $i) in actions">
                <v-list-item
                  :key="$i"
                  @click="item[`_show-${actionItem.type}-modal`] = true"
                >
                  <v-list-item-icon>
                    <v-icon small v-text="actionItem.icon"></v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ actionItem.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import MasterdataModal from './MasterdataModal'
import MasterdataCreateButton from './MasterdataCreateButton'
import inputTableHeight from '@/mixins/inputTableHeight'

export default {
  name: 'MasterdataTableContainer',

  mixins: [inputTableHeight(187)],

  components: {
    MasterdataCreateButton,
    MasterdataModal
  },

  props: {
    value: {
      type: Array,
      default: () => []
    },
    itemKey: {
      type: String,
      default: () => 'uuid'
    },
    pagination: {
      type: Boolean,
      default: () => true
    },
    sortDesc: Boolean,
    showSelect: Boolean,
    refetch: Function,
    loading: Boolean,
    headers: Array,
    tableData: Array,
    sortBy: String,
    actions: {
      type: Array,
      default: () => []
    },
    components: Object
  },

  computed: {
    selected: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    },
    data() {
      return this.tableData
        .filter(x => !x.deleted)
        .map(x => ({
          ...x,
          ...this.actions.reduce((acc, action) => {
            acc[`_show-${action.type}-modal`] = false
            return acc
          }, {})
        }))
    }
  },

  data: () => ({ search: '' })
}
</script>
